/**
 * Refusable consent helpers — parent must choose consent OR explicit decline (recorded).
 */

export function requiredConsentAckSatisfied(fields, ackKey) {
  return !!fields?.[ackKey];
}

export function pushRequiredConsentAck(errors, fieldErrorMap, fields, ackKey, label) {
  if (!fields?.[ackKey]) {
    const msg = `${label} is required for admission`;
    errors.push({ id: `packet-field-${ackKey}`, fieldKey: ackKey, message: msg });
    fieldErrorMap[ackKey] = msg;
  }
}

export function consentAckDeclineSatisfied(fields, ackKey, declineKey) {
  const ack = !!fields?.[ackKey];
  const decline = !!fields?.[declineKey];
  if (ack && decline) return false;
  return ack || decline;
}

export function pushConsentAckDecline(errors, fieldErrorMap, fields, ackKey, declineKey, label) {
  const ack = !!fields?.[ackKey];
  const decline = !!fields?.[declineKey];
  if (ack && decline) {
    const msg = `Choose consent or decline for ${label} — not both`;
    errors.push({ id: `packet-field-${declineKey}`, fieldKey: declineKey, message: msg });
    fieldErrorMap[declineKey] = msg;
    return;
  }
  if (!ack && !decline) {
    const msg = `Please consent or decline: ${label}`;
    errors.push({ id: `packet-field-${ackKey}`, fieldKey: ackKey, message: msg });
    fieldErrorMap[ackKey] = msg;
  }
}

/** fa_09: at least one service OR explicit decline-all. */
export function fa09RemoteLearningSatisfied(fields) {
  if (fields?.remote_learning_decline) {
    const anyService = [
      'remote_classroom',
      'remote_speech',
      'remote_ot',
      'remote_pt',
      'remote_counseling',
    ].some((k) => !!fields[k]);
    return !anyService;
  }
  return [
    'remote_classroom',
    'remote_speech',
    'remote_ot',
    'remote_pt',
    'remote_counseling',
  ].some((k) => !!fields[k]);
}
